import React, { useState } from "react";
import ContactForm from "./Contact";

const TravelCard = ({ packageData }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            {/* Travel Card */}
            <div
                className="relative h-[50vh] bg-cover bg-center shadow-lg overflow-hidden"
                style={{ backgroundImage: `url('${packageData?.Images}')` }}
            >
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black flex flex-col items-start justify-end p-6">
                    <h2 className="text-lg font-semibold text-yellow-400">
                        Travel isn’t about the destination—it’s about the memories you create along the way.
                    </h2>
                    <h1 className="text-4xl font-bold text-white mt-2">
                        {packageData?.Destnation} - {packageData?.Duration}
                    </h1>
                    <p className="text-lg text-gray-200 mt-2">
                        {packageData?.Overview.substring(0, 100)}...
                    </p>
                    <div className="mt-4">
                        <button className="bg-white text-black px-5 py-2 rounded-full mr-3 hover:bg-gray-200 transition duration-300">
                            Get Itinerary
                        </button>
                        <button
                            className="bg-yellow-500 text-white px-5 py-2 rounded-full shadow-md hover:bg-yellow-400 transition duration-300"
                            onClick={() => setIsModalOpen(true)}
                        >
                            Book Now
                        </button>
                    </div>
                </div>
            </div>

            {/* ContactForm Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-[700px] relative">
                        <button
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                            onClick={() => setIsModalOpen(false)}
                        >
                            ✖
                        </button>
                        <h2 className="text-2xl font-bold text-center mb-4">Book Your Trip</h2>
                        <ContactForm />
                    </div>
                </div>
            )}
        </>
    );
};

export default TravelCard;
